import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Link } from '@ta-interaktiv/contentbricks'

export const isMobile: boolean = browserCheck.isMobile

const updates = { evening: 'Actualisé à 18 heures, sauf durant le week-end' }

const metaCases = 'Fälle'

export const localesHospitalMultiples = {
  title: 'Patients covid actuellement à l’hôpital',
  subline: (
    <>
      AI: pas de données disponibles. GE: Jusqu’au 18 mai 2020, les patients en
      réanimation ne sont pas comptés. SZ: Pas de données pour la 1e vague.
    </>
  ),
  link: (
    <>
      Taux d’occupation des hôpitaux par canton:{' '}
      <Link href='TODO-wch-story-id'>Voir les infographies</Link>.
    </>
  ),
  update: updates.evening,
  swissTitle: 'En Suisse',
  keyHosp: 'Hospitalisé',
  keyIntensive: 'En soins intensifs',
  metaCases: metaCases,
  showMoreClosed: 'Voir tous les cantons',
  showMoreOpened: 'Voir une sélection de cantons',
  noData: 'Pas de données',
  emptyData: 'Pas de données',
  timerange: ['Time range']
}
